import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import CustumRoutes from './routes/index.js';
import { persistor, store } from './store/store';
import './App.css';
import GlobalSpinner from './spinner/GlobalSpinner.js';
function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
  return (
    <div className="App">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <GlobalSpinner/>
              <ToastContainer
                theme='light'
                autoClose={3000} />
              <CustumRoutes />
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
